import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  template: `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 80vh;">
      <h1 style="font-size: 48px; color: #e74c3c; margin-bottom: 16px;">403</h1>
      <h2 style="margin-bottom: 8px;">Access Denied</h2>
      <p style="color: #666;">You do not have admin privileges to access this application.</p>
    </div>
  `,
})
export class AccessDeniedComponent {}
